export default __webpack_public_path__ + "static/travel-81180d38f832bd4ec9c24b760524a8a4.mp4";